"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationSessionTimeWorkedDto = instanceOfOrientationSessionTimeWorkedDto;
exports.OrientationSessionTimeWorkedDtoFromJSON = OrientationSessionTimeWorkedDtoFromJSON;
exports.OrientationSessionTimeWorkedDtoFromJSONTyped = OrientationSessionTimeWorkedDtoFromJSONTyped;
exports.OrientationSessionTimeWorkedDtoToJSON = OrientationSessionTimeWorkedDtoToJSON;
exports.OrientationSessionTimeWorkedDtoToJSONTyped = OrientationSessionTimeWorkedDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationSessionTimeWorkedDto interface.
 */
function instanceOfOrientationSessionTimeWorkedDto(value) {
    if (!('orientationSessionId' in value) || value['orientationSessionId'] === undefined)
        return false;
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    return true;
}
function OrientationSessionTimeWorkedDtoFromJSON(json) {
    return OrientationSessionTimeWorkedDtoFromJSONTyped(json, false);
}
function OrientationSessionTimeWorkedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orientationSessionId': json['orientationSessionId'],
        'minutesWorked': json['minutesWorked'],
        'skippedMealBreak': json['skippedMealBreak'] == null ? undefined : json['skippedMealBreak'],
        'didNotWork': json['didNotWork'] == null ? undefined : json['didNotWork'],
    };
}
function OrientationSessionTimeWorkedDtoToJSON(json) {
    return OrientationSessionTimeWorkedDtoToJSONTyped(json, false);
}
function OrientationSessionTimeWorkedDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orientationSessionId': value['orientationSessionId'],
        'minutesWorked': value['minutesWorked'],
        'skippedMealBreak': value['skippedMealBreak'],
        'didNotWork': value['didNotWork'],
    };
}
//# sourceMappingURL=OrientationSessionTimeWorkedDto.js.map